import React from 'react'
import PropTypes from 'prop-types'
import Image from 'next/image'

import { Column, Row, Rows, Section } from '@/components/layout'
import { Link, Text } from '@/components/common'

import styles from './FeatureSection.module.scss'

export default function FeatureSection({
  title,
  content,
  ctaProps = {},
  imgProps = {},
  rightImage = false,
  secondary = false,
  sectionProps = {},
}) {
  const renderImage = () => {
    const { src, alt, ...restImgProps } = imgProps
    if (!src) return null
    return (
      <Column center size={50}>
        <Image alt={alt} src={src} {...restImgProps} />
      </Column>
    )
  }

  const renderCta = () => {
    if (!ctaProps.to) return null
    return <Link iconProps={{ name: 'chevron-right', position: 'right' }} size="large" variant="primary" {...ctaProps} />
  }

  return (
    <Section bgSecondary={secondary} className={styles.sectionContent} {...sectionProps}>
      <Row>
        {!rightImage && renderImage()}
        <Column center gap={32} size={50}>
          <Rows className="w-full max-w-400">
            <Text.H2>{title}</Text.H2>
            <Text.P>{content}</Text.P>
            {renderCta()}
          </Rows>
        </Column>
        {rightImage && renderImage()}
      </Row>
    </Section>
  )
}

FeatureSection.propTypes = {
  content: PropTypes.node,
  ctaProps: PropTypes.shape({
    to: PropTypes.string,
  }),
  imgProps: PropTypes.shape({
    alt: PropTypes.string,
    src: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    width: PropTypes.number.isRequired,
    height: PropTypes.number,
  }),
  rightImage: PropTypes.bool,
  secondary: PropTypes.bool,
  sectionProps: PropTypes.shape({}),
  title: PropTypes.node.isRequired,
}
